/**
 * Unit conversion constants
 * Centralizes all unit conversion factors for 3D rendering
 *
 * Units: Store = feet (user-friendly), Rendering = meters (Mapbox/Three.js)
 */

export const FEET_TO_METERS = 0.3048
export const METERS_TO_FEET = 1 / FEET_TO_METERS

/**
 * Convert feet to meters
 */
export function feetToMeters(feet: number): number {
  return feet * FEET_TO_METERS
}

/**
 * Convert meters to feet
 */
export function metersToFeet(meters: number): number {
  return meters * METERS_TO_FEET
}

/**
 * Convert position array from feet to meters
 */
export function positionFeetToMeters(position: [number, number, number]): [number, number, number] {
  return [
    position[0] * FEET_TO_METERS,
    position[1] * FEET_TO_METERS,
    position[2] * FEET_TO_METERS
  ]
}

/**
 * Convert position array from meters to feet
 */
export function positionMetersToFeet(position: [number, number, number]): [number, number, number] {
  return [
    position[0] * METERS_TO_FEET,
    position[1] * METERS_TO_FEET,
    position[2] * METERS_TO_FEET
  ]
}
